import { ModelBase } from 'store/model-base';

export class ReturnInfo extends ModelBase {
    public static storeName: string = 'returnInfo';

    public returnOrderSuccess: ReturnOrderSuccess;
    public orderValue: string;
}
